import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// Selectors
import {
    selectEntityTypesExist
    // @ts-ignore
} from 'services/entityTypes/selectors';

export interface OwnProps {
    children: React.ReactNode;
    FallbackComponent?: React.ReactNode;
}

interface StateProps {
    entityTypesExist?: boolean;
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class EntityTypesExistGate extends React.PureComponent<IProps> {
    render() {
        const { children, FallbackComponent, entityTypesExist } = this.props;
        if (!entityTypesExist) return FallbackComponent || null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    entityTypesExist: selectEntityTypesExist
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    EntityTypesExistGate
);
